import React, { createContext, useContext, useState } from 'react';

const PartyAuthContext = createContext(null);

export function PartyAuthProvider({ children }) {
  const [party, setParty] = useState(() => {
    const stored = localStorage.getItem('party_data');
    return stored ? JSON.parse(stored) : null;
  });

  const login = (token, partyData) => {
    localStorage.setItem('party_token', token);
    localStorage.setItem('party_data', JSON.stringify(partyData));
    setParty(partyData);
  };

  const logout = () => {
    localStorage.removeItem('party_token');
    localStorage.removeItem('party_data');
    setParty(null);
  };

  return (
    <PartyAuthContext.Provider value={{ party, login, logout }}>
      {children}
    </PartyAuthContext.Provider>
  );
}

export function usePartyAuth() {
  return useContext(PartyAuthContext);
}
